// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.admin-table-wrap .current-page {
  float: right;
  margin-right: 2rem;
}

.admin-list-table {
  border: 0.1rem solid #c0c0c0;
  width: 100%;
  margin-bottom: 2rem;
  padding: 0;
  border-collapse: collapse;
  border-spacing: 0;
}
.admin-list-table tr.admin-table-tr {
  border: 0.1rem solid #c0c0c0;
  padding: 0.5rem;
}
.admin-list-table tr.admin-table-tr.clickable-row:hover {
  cursor: pointer;
}
.admin-list-table tr.admin-table-tr:nth-of-type(2n) {
  background-color: #f3f3f3;
}
.admin-list-table tr.admin-table-tr:hover {
  background-color: #dadada;
}
.admin-list-table th.admin-table-th,
.admin-list-table td.admin-table-td {
  padding: 1.5rem 2.5rem;
  text-align: left;
  font-size: 1.4rem;
  border-right: 0.1rem solid #c0c0c0;
}
.admin-list-table th.admin-table-th a,
.admin-list-table td.admin-table-td a {
  color: black;
}
.admin-list-table th.admin-table-th a:hover,
.admin-list-table td.admin-table-td a:hover {
  color: #f5a000;
}
.admin-list-table td.admin-table-td {
  word-wrap: break-word;
}
.admin-list-table th.admin-table-th {
  font-size: 1.5rem;
  font-weight: normal;
  color: white;
  background: #696969;
  font-weight: 700;
  letter-spacing: 1;
}
.admin-list-table th:hover .sort-by-arrow {
  display: block;
}
.admin-list-table .sort-by-arrow {
  display: none;
}

@media screen and (max-width: 768px) {
  table.admin-list-table {
    border: 0;
  }
  table.admin-list-table thead {
    display: none;
  }
  table.admin-list-table tr.admin-table-tr {
    margin-bottom: 1rem;
    display: block;
    border-bottom: 0.2rem solid #ddd;
  }
  table.admin-list-table td.admin-table-td {
    width: unset !important; /*This will override any width we have set on the table such as Actions column*/
    display: block;
    text-align: right;
    font-size: 1.3rem;
    border-bottom: 0.1rem dotted #c0c0c0;
  }
  table.admin-list-table td.admin-table-td div.tableInfo:before {
    content: ":";
    padding-right: 1rem;
    display: inline-block;
  }
  table.admin-list-table td.admin-table-td .fa {
    color: black;
  }
  table.admin-list-table td.admin-table-td .fa:hover {
    cursor: pointer;
    color: red;
  }
  table.admin-list-table td.admin-table-td:last-child {
    border-bottom: 0;
  }
  table.admin-list-table td.admin-table-td:before {
    content: attr(data-label);
    float: left;
    text-transform: uppercase;
    font-weight: bold;
  }
}
.admin-list-table-search {
  width: 45%;
  float: left;
  display: inline-block;
}
.admin-list-table-search input[type=text] {
  max-width: 25rem;
  float: left;
  margin-right: 0.5rem;
}

.admin-list-search-submit.fa-lg {
  display: inline-block;
  margin-left: 0.7rem;
  vertical-align: bottom;
}
.admin-list-search-submit.fa-lg:hover {
  cursor: pointer;
  color: red;
}

.admin-table-header,
.admin-table-footer {
  display: block;
  clear: both;
}

.admin-table-pagination {
  width: 50%;
  display: inline-block;
  float: right;
  clear: both;
}
.admin-table-pagination .enter-page {
  width: 7.5rem;
  display: inline-block;
  margin: 0 1rem;
  text-align: right;
}
.admin-table-pagination .next-page,
.admin-table-pagination .prev-page {
  float: right;
  background: none;
  border: none;
  color: black;
  padding: 0.9rem 1rem 0.5rem 1rem;
}
.admin-table-pagination .next-page:hover,
.admin-table-pagination .prev-page:hover {
  cursor: pointer;
  color: red;
}
.admin-table-pagination .next-page:hover,
.admin-table-pagination .prev-page:hover {
  background: none;
}

.iconButton.prev-page,
.iconButton.next-page {
  float: right;
}

.admin-table-wrap.condensed td.admin-table-td,
.admin-table-wrap.condensed th.admin-table-th {
  padding: 0.8rem 1rem;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Global/Table/Table.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AACE;EACE,YAAA;EACA,kBAAA;AAEJ;;AAEA;EACE,4BAAA;EACA,WAAA;EACA,mBAAA;EACA,UAAA;EACA,yBAAA;EACA,iBAAA;AACF;AACE;EACE,4BAAA;EACA,eAAA;AACJ;AAEE;EACE,eAAA;AAAJ;AAGE;EACE,yBAAA;AADJ;AAIE;EACE,yBAAA;AAFJ;AAKE;;EAEE,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kCAAA;AAHJ;AAII;;EACE,YAAA;AADN;AAGI;;EACE,cDRG;ACQT;AAIE;EACE,qBAAA;AAFJ;AAKE;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBDrDY;ECsDZ,gBAAA;EACA,iBAAA;AAHJ;AAME;EACE,cAAA;AAJJ;AAOE;EACE,aAAA;AALJ;;AAUA;EACE;IACE,SAAA;EAPF;EAQE;IACE,aAAA;EANJ;EASE;IACE,mBAAA;IACA,cAAA;IACA,gCAAA;EAPJ;EAUE;IACE,uBAAA,EAAA,+EAAA;IACA,cAAA;IACA,iBAAA;IACA,iBAAA;IACA,oCAAA;EARJ;EASI;IACE,YAAA;IACA,mBAAA;IACA,qBAAA;EAPN;EAWE;IACE,YAAA;EATJ;EAUI;IACE,eAAA;IACA,UDnEO;EC2Db;EAYE;IACE,gBAAA;EAVJ;EAaE;IACE,yBAAA;IACA,WAAA;IACA,yBAAA;IACA,iBAAA;EAXJ;AACF;AAeA;EACE,UAAA;EACA,WAAA;EACA,qBAAA;AAbF;AAcE;EACE,gBAAA;EACA,WAAA;EACA,oBAAA;AAZJ;;AAgBA;EACE,qBAAA;EAKA,mBAAA;EACA,sBAAA;AAjBF;AAYE;EACE,eAAA;EACA,UDnGW;ACyFf;;AAgBA;;EAEE,cAAA;EACA,WAAA;AAbF;;AAgBA;EACE,UAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;AAbF;AAcE;EACE,aAAA;EACA,qBAAA;EACA,cAAA;EACA,iBAAA;AAZJ;AAeE;;EAEE,YAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,gCAAA;AAbJ;AAcI;;EACE,eAAA;EACA,UDpIS;ACyHf;AAaI;;EACE,gBAAA;AAVN;;AAeA;;EAEE,YAAA;AAZF;;AAgBE;;EAEE,oBAAA;AAbJ","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n\n.admin-table-wrap {\n  .current-page {\n    float: right;\n    margin-right: 2rem;\n  }\n}\n\n.admin-list-table {\n  border: 0.1rem solid $borderColor;\n  width: 100%;\n  margin-bottom: 2rem;\n  padding: 0;\n  border-collapse: collapse;\n  border-spacing: 0;\n\n  tr.admin-table-tr {\n    border: 0.1rem solid $borderColor;\n    padding: 0.5rem;\n  }\n\n  tr.admin-table-tr.clickable-row:hover {\n    cursor: pointer;\n  }\n\n  tr.admin-table-tr:nth-of-type(2n) {\n    background-color: lighten($borderColor, 20%);\n  }\n\n  tr.admin-table-tr:hover {\n    background-color: lighten($borderColor, 10%);\n  }\n\n  th.admin-table-th,\n  td.admin-table-td {\n    padding: 1.5rem 2.5rem;\n    text-align: left;\n    font-size: 1.4rem;\n    border-right: 0.1rem solid $borderColor;\n    a {\n      color: black;\n    }\n    a:hover {\n      color: $orange;\n    }\n  }\n\n  td.admin-table-td {\n    word-wrap: break-word;\n  }\n\n  th.admin-table-th {\n    font-size: 1.5rem;\n    font-weight: normal;\n    color: white;\n    background: $darkTextColor;\n    font-weight: 700;\n    letter-spacing: 1;\n  }\n\n  th:hover .sort-by-arrow {\n    display: block;\n  }\n\n  .sort-by-arrow {\n    display: none;\n  }\n}\n\n// Force tables into a vertical format with 100% width rows on mobile devices\n@media screen and (max-width: 768px) {\n  table.admin-list-table {\n    border: 0;\n    thead {\n      display: none;\n    }\n\n    tr.admin-table-tr {\n      margin-bottom: 1rem;\n      display: block;\n      border-bottom: 0.2rem solid #ddd;\n    }\n\n    td.admin-table-td {\n      width: unset !important; /*This will override any width we have set on the table such as Actions column*/\n      display: block;\n      text-align: right;\n      font-size: 1.3rem;\n      border-bottom: 0.1rem dotted $borderColor;\n      div.tableInfo:before {\n        content: ':';\n        padding-right: 1rem;\n        display: inline-block;\n      }\n    }\n\n    td.admin-table-td .fa {\n      color: black;\n      &:hover {\n        cursor: pointer;\n        color: $brand-danger;\n      }\n    }\n\n    td.admin-table-td:last-child {\n      border-bottom: 0;\n    }\n\n    td.admin-table-td:before {\n      content: attr(data-label);\n      float: left;\n      text-transform: uppercase;\n      font-weight: bold;\n    }\n  }\n}\n\n.admin-list-table-search {\n  width: 45%;\n  float: left;\n  display: inline-block;\n  input[type='text'] {\n    max-width: 25rem;\n    float: left;\n    margin-right: 0.5rem;\n  }\n}\n\n.admin-list-search-submit.fa-lg {\n  display: inline-block;\n  &:hover {\n    cursor: pointer;\n    color: $brand-danger;\n  }\n  margin-left: 0.7rem;\n  vertical-align: bottom;\n}\n\n.admin-table-header,\n.admin-table-footer {\n  display: block;\n  clear: both;\n}\n\n.admin-table-pagination {\n  width: 50%;\n  display: inline-block;\n  float: right;\n  clear: both;\n  .enter-page {\n    width: 7.5rem;\n    display: inline-block;\n    margin: 0 1rem;\n    text-align: right;\n  }\n\n  .next-page,\n  .prev-page {\n    float: right;\n    background: none;\n    border: none;\n    color: black;\n    padding: 0.9rem 1rem 0.5rem 1rem;\n    &:hover {\n      cursor: pointer;\n      color: $brand-danger;\n    }\n    &:hover {\n      background: none;\n    }\n  }\n}\n\n.iconButton.prev-page,\n.iconButton.next-page {\n  float: right;\n}\n\n.admin-table-wrap.condensed {\n  td.admin-table-td,\n  th.admin-table-th {\n    padding: 0.8rem 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
